import { useCallback, useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { useTheme } from '@mui/material/styles';

import MUIAppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

import MenuIcon from '@mui/icons-material/Menu';

import { useBreakpoints } from '@/hooks';

import { appStore } from '@/store';

import { LanguageSwitcher } from '../../LanguageSwitcher';

import { UserMenu } from './UserMenu';

function AppBar() {
  const theme = useTheme();

  const { isMobileDevice, useUp } = useBreakpoints();

  const navigate = useNavigate();
  const [appBarHeight, setAppBarHeight] = useState(0);

  const handleBurgerMenuClick = () => {
    appStore.appDrawer.open = true;
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  const appBarRef = useCallback((node: HTMLElement) => {
    if (node !== null) {
      setAppBarHeight(node.getBoundingClientRect().height);
    }
  }, []);

  // store app bar height to dynamically calculate remaining content height
  useEffect(() => {
    appStore.appBar.height = appBarHeight;
  }, [appBarHeight]);

  return (
    <MUIAppBar
      position="relative"
      sx={{
        zIndex: theme.zIndex.appBar,
        backgroundColor: 'background.paper',
      }}
      ref={appBarRef}
    >
      <Toolbar
        variant="dense"
        sx={{
          pl: `${theme.spacing(2)} !important`,
          pr: `${theme.spacing(2)} !important`,
        }}
      >
        {/* hide burger menu on mobile devices */}
        {!isMobileDevice && (
          <IconButton
            size="large"
            edge="start"
            sx={{ mr: 2 }}
            onClick={handleBurgerMenuClick}
          >
            <MenuIcon />
          </IconButton>
        )}

        {/* logo */}
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
          }}
        >
          {/* logo 446 × 94*/}
          <img
            src="/greensee.png"
            width={144}
            height={30}
            onClick={handleLogoClick}
            style={{ cursor: 'pointer' }}
          />
        </Box>

        <Typography
          sx={{
            display: 'none',
            mr: 4,
          }}
          fontSize={isMobileDevice ? 12 : 18}
          color="black"
        >{`up xs:${useUp('xs')} sm:${useUp('sm')} md:${useUp('md')} lg:${useUp(
          'lg',
        )} xl:${useUp('xl')}`}</Typography>

        <Stack direction="row" spacing={2} alignItems="center">
          <LanguageSwitcher />
          {/* hide notification icon on mobile devices */}
          {/* {!isMobileDevice && <Notifications />} */}
          {/* user avatar menu */}
          <UserMenu />
        </Stack>
      </Toolbar>
    </MUIAppBar>
  );
}

export { AppBar };
